import {
    createAsyncThunk
} from "@reduxjs/toolkit";
import api from "../../store/api/api"
import {
    headerConfiguration,
    headers
} from "../../store/auth/headerConfig";
import {
    toast
} from "react-toastify";



export const createDebate = createAsyncThunk(
    "debates/createDebate",
    async (payload, {
        dispatch,
        getState
    }) => {

        try {

            const url = `${process.env.REACT_APP_SERVER_URL}/api/debates/`

            // Create FormData object
            const formData = new FormData();
            formData.append('topic', payload.topic);
            formData.append('description', payload.description);
            formData.append('author', payload.author);
            formData.append('start_at', payload.start_at);
            formData.append('duration', payload.duration);
            formData.append('supporting', JSON.stringify(payload.supporting));
            formData.append('opposing', JSON.stringify(payload.opposing));

            // Append each media file
            if (payload.media && payload.media.length > 0) {
                payload.media.forEach((file) => {
                    formData.append('media', file);
                });
            }



            const headerConfig = headerConfiguration(getState, headers, true);
            delete headerConfig['Content-Type']; // Important: remove Content-Type header

            toast.loading("Creating debate...")
            const response = await api(url, "POST", headerConfig, formData, dispatch);
            toast.dismiss()
            if(response){
                // response?.debate_id
                toast.success(response?.message)
            }
            return response;

        } catch (error) {
            console.error(error);
            toast.dismiss()
            toast.error(error.message || 'Failed to create debate');
            return error;
        }

    }
)


export const getAllDebates = createAsyncThunk(
    "debates/getAllDebates",
    async (payload,{dispatch, getState}) => {

        const queryparam1 = payload?.search ? `search=${payload?.search}` : ""
        const queryparam2 = payload?.page ? `page=${payload?.page}` : ""
        try {

            const url = `${process.env.REACT_APP_SERVER_URL}/api/debates/?${queryparam1}${queryparam2}`
            const headerConfig = headerConfiguration(getState, headers)
            const response = await api(url, "GET", headerConfig, null, dispatch)
            return response

        } catch (error) {
            console.log(error)
            return error
        }
    }
)


export const getEachDebate = createAsyncThunk(
    "debates/getEachDebate",
    async (payload,{dispatch, getState}) => {

        try {
            const url = `${process.env.REACT_APP_SERVER_URL}/api/debates/${payload.debate_id}/`
            const headerConfig = headerConfiguration(getState, headers)
            const response = await api(url, "GET", headerConfig, null, dispatch)
            return response

        } catch (error) {
            console.log(error)
            return error
        }
    }
)


export const deleteDebate = createAsyncThunk(
    "debates/deleteDebate",
    async (payload,{dispatch, getState}) => {

        try {
            const url = `${process.env.REACT_APP_SERVER_URL}/api/debates/${payload.debate_id}/`
            const headerConfig = headerConfiguration(getState, headers)
            const body = {
                user_id : payload.user_id
            }
            const response = await api(url, "DELETE", headerConfig, body, dispatch)
            return response

        } catch (error) {
            console.log(error)
            return error
        }
    }
)

export const getDebatePoints = createAsyncThunk(
    "debates/getDebatePoints",
    async (payload,{dispatch, getState}) => {

        try {
            const url = `${process.env.REACT_APP_SERVER_URL}/api/debates/arguments/${payload.debate_id}/`
            const headerConfig = headerConfiguration(getState, headers)
            const response = await api(url, "GET", headerConfig, null, dispatch)
            return response

        } catch (error) {
            console.log(error)
            return error
        }
    }
)


export const postDebateArgument = createAsyncThunk(
    "debates/postDebateArgument",
    async (payload, {
        dispatch,
        getState
    }) => {

        try {

            const url = `${process.env.REACT_APP_SERVER_URL}/api/debates/arguments/${payload.debate_id}/`

            // Create FormData object
            const formData = new FormData();
            formData.append('author', payload.author);
            formData.append('text', payload.text);
            formData.append('side', payload.side);
            formData.append('debate_id', payload.debate_id);


            // Append each media file
            if (payload.media && payload.media.length > 0) {
                payload.media.forEach((file) => {
                    formData.append('media', file);
                });
            }

            const headerConfig = headerConfiguration(getState, headers, true);
            delete headerConfig['Content-Type']; // Important: remove Content-Type header

            toast.loading("Processing...")
            const response = await api(url, "POST", headerConfig, formData, dispatch);
            toast.dismiss()
            if(response){
                toast.success(response?.message)
            }
            return response;

        } catch (error) {
            console.error(error);
            toast.dismiss()
            toast.error(error.message || 'Failed to create points');
            return error;
        }

    }
)

export const startDebate = createAsyncThunk(
    "debates/startDebate",
    async (payload,{dispatch, getState}) => {

        try {
            const url = `${process.env.REACT_APP_SERVER_URL}/api/debates/${payload.debate_id}/`
            const headerConfig = headerConfiguration(getState, headers)
            const response = await api(url, "PATCH", headerConfig, null, dispatch)
            toast.dismiss()
            if(response){
                toast.success(response?.message)
            }
            return response

        } catch (error) {
            console.log(error)
            return error
        }
    }
)


export const debateCountDown = createAsyncThunk(
    "debates/debateCountDown",
    async (payload,{dispatch, getState}) => {

        try {
            const url = `${process.env.REACT_APP_SERVER_URL}/api/debates/timer/${payload.debate_id}/`
            const headerConfig = headerConfiguration(getState, headers)
            const response = await api(url, "GET", headerConfig, null, dispatch)
            return response

        } catch (error) {
            console.log(error)
            return error
        }
    }
)


export const createDebateComment = createAsyncThunk(
    "debates/createDebateComment",
    async ({debate_id, author, text, parent, media},{dispatch, getState}) => {

        try {
            const url = `${process.env.REACT_APP_SERVER_URL}/api/debates/comments/${debate_id}/`



            // Create FormData object
            const formData = new FormData();
            formData.append('text', text);
            formData.append('author', author);
            formData.append('parent', parent);


            // Append each media file
            if (media && media.length > 0) {
                media.forEach((file) => {
                    formData.append('media', file);
                });
            }

            const headerConfig = headerConfiguration(getState, headers, true);
            delete headerConfig['Content-Type']; // Important: remove Content-Type header

            toast.loading("Processing...")
            const response = await api(url, "POST", headerConfig, formData, dispatch)
            toast.dismiss()
            if(response){
                toast.success(response?.message)
            }
            return response;

        } catch (error) {
            console.error(error);
            toast.dismiss()
            toast.error(error?.message || 'Failed to create comment');
            return error;
        }
    }
)


export const getEachDebateComments = createAsyncThunk(
    "debates/getEachDebateComments",
    async (payload,{dispatch, getState}) => {

        try {
            const url = `${process.env.REACT_APP_SERVER_URL}/api/debates/comments/${payload.debate_id}/`
            const headerConfig = headerConfiguration(getState, headers)
            const response = await api(url, "GET", headerConfig, null, dispatch)
            return response

        } catch (error) {
            console.log(error)
            return error
        }
    }
)


export const getEachDebateCommentReplies = createAsyncThunk(
    "debates/getEachDebateCommentReplies",
    async (payload,{dispatch, getState}) => {

        try {
            const url = `${process.env.REACT_APP_SERVER_URL}/api/debates/comments/replies/${payload.comment_eid}`
            const headerConfig = headerConfiguration(getState, headers)
            const response = await api(url, "GET", headerConfig, null, dispatch)
            return response

        } catch (error) {
            console.log(error)
            return error
        }
    }
)



export const editDebateComment = createAsyncThunk(
    "debates/editDebateComment",
    async (payload,{dispatch, getState}) => {

        const body ={
            text : payload.edited_comment
        }

        try {
            const url = `${process.env.REACT_APP_SERVER_URL}/api/debates/comments/${payload?.eid}/`
            const headerConfig = headerConfiguration(getState, headers)
            const response = await api(url, "PATCH", headerConfig, body, dispatch)
            return response;

        } catch (error) {
            console.error(error);
            toast.dismiss()
            toast.error(error?.message || 'Failed to edit comment');
            return error;
        }
    }
)


export const deleteDebateComments = createAsyncThunk(
    "debates/deleteDebateComments",
    async (payload,{dispatch, getState}) => {

        try {
            const url = `${process.env.REACT_APP_SERVER_URL}/api/debates/comments/${payload?.eid}/`
            const headerConfig = headerConfiguration(getState, headers)
            const response = await api(url, "DELETE", headerConfig, null, dispatch)
            return response

        } catch (error) {
            console.log(error)
            return error
        }
    }
)

export const debatePsychometricsSuggest = createAsyncThunk(
    "debates/debatePsychometricsSuggest",
    async (payload,{dispatch, getState}) => {


        const body ={
            target_id : payload?.target_id,
            username : payload?.username,
            suggestion : payload?.opinion,
            evidence : payload?.source,
            argument_type: payload?.argument
        }

        try {
            const url = `${process.env.REACT_APP_SERVER_URL}/api/debates/comments/psychometrics/${payload.debate_id}/`
            const headerConfig = headerConfiguration(getState, headers)
            const response = await api(url, "POST", headerConfig, body, dispatch)
            if(response){
                toast.success("Suggestions and Graph Updated")
            }

            return response;

        } catch (error) {
            console.error(error);
            toast.dismiss()
            toast.error(error?.message || 'Failed to create comment');
            return error;
        }
    }
)


export const getEachDebatePsychometrics = createAsyncThunk(
    "debates/getEachDebatePsychometrics",
    async (payload,{dispatch, getState}) => {

        try {
            const url = `${process.env.REACT_APP_SERVER_URL}/api/debates/comments/psychometrics/${payload.debate_id}/`
            const headerConfig = headerConfiguration(getState, headers)
            const response = await api(url, "GET", headerConfig, null, dispatch)
            return response

        } catch (error) {
            console.log(error)
            return error
        }
    }
)

export const debatePsychometricsFactCheckMe = createAsyncThunk(
    "debates/debatePsychometricsFactCheckMe",
    async (payload,{dispatch, getState}) => {


        const body ={
            node_id : payload?.node_id,
            username : payload?.username,
            suggestion : payload?.opinion,
            evidence : payload?.source,
        }


        try {
            const url = `${process.env.REACT_APP_SERVER_URL}/api/debates/comments/psychometrics/${payload.debate_id}/`
            const headerConfig = headerConfiguration(getState, headers)
            const response = await api(url, "PUT", headerConfig, body, dispatch)
            if(response){
                toast.success("Your Suggestions and the Graph was Updated")
            }
            return response;

        } catch (error) {
            console.error(error);
            toast.dismiss()
            toast.error(error?.message || 'Failed to create comment');
            return error;
        }
    }
)


export const debateFactCheckOthers = createAsyncThunk(
    "debates/debateFactCheckOthers",
    async (payload,{dispatch, getState}) => {


        const body ={
            node_id : payload?.node_id,
            username : payload?.username,
            argument : payload?.argument,
            source : payload?.source,
        }


        try {
            const url = `${process.env.REACT_APP_SERVER_URL}/api/debates/fact-check/psychometrics/${payload.debate_id}/`
            const headerConfig = headerConfiguration(getState, headers)
            const response = await api(url, "POST", headerConfig, body, dispatch)
            if(response){
                toast.success("Suggestions metrics Updated")
            }

            return response;

        } catch (error) {
            console.error(error);
            toast.dismiss()
            toast.error(error?.message || 'Failed to create comment');
            return error;
        }
    }
)

// UPVOTE OR DOWNVOTE
export const debate_reaction_activity = createAsyncThunk(
    'debates/debate_reaction_activity',
    async ({eid,user_id,parent_id,vote_type}, {getState, dispatch}) => {

        const headerConfig = headerConfiguration(getState, headers)
        try{
            const url = `${process.env.REACT_APP_SERVER_URL}/api/debates/comments/${user_id}/reaction/${eid}/${parent_id}/`
            const body = {
                vote_type
            }
            const response = await api(url, "POST", headerConfig, body, dispatch)
            // console.log("response", response)
            return response;
        }catch(error){
        // console.error(error)
        return (error?.message);
        }
    }
)


// UPVOTE OR DOWNVOTE
export const get_debates_reaction_activity_by_user = createAsyncThunk(
    'debates/get_debates_reaction_activity_by_user',
    async ({eid,user_id,parent_id}, {getState, dispatch}) => {
        const headerConfig = headerConfiguration(getState, headers)
        try{
            const url = `${process.env.REACT_APP_SERVER_URL}/api/debates/comments/${user_id}/reaction/${eid}/${parent_id}/`
            const response = await api(url, "GET", headerConfig, null, dispatch)
            return response;
        }catch(error){
         // console.error(error)
        return (error?.message);
        }
    }
)


